import React from 'react';
import styled from 'styled-components';
import Value from './Value';

const Wrapper = styled.div`
  .container {
    max-width: 1300px !important;
    padding-top: 60px;
    padding-bottom: 60px;

    display: grid;

    grid-template-columns: ${({ valuePropsLength }) =>
      `repeat(${valuePropsLength}, 1fr)`};
    grid-gap: 40px;
  }

  .value-prop {
  }
`;

function ValueProposition({ className, productData }) {
  const categoryId = productData?.frame?.subcategories[0]?.category.id;
  const assemblyAvailable = productData?.frame?.shippingServices.some(
    x => parseInt(x.id) === 1
  );
  const isWarranty = productData?.warranty;

  const valueProps = valuesPropsToShow(
    categoryId,
    assemblyAvailable,
    isWarranty,
    productData
  );

  const hideMadeToOrder = [28, 30, 31].includes(parseInt(categoryId));

  return (
    <Wrapper
      className={className ? className : ''}
      hideMadeToOrder={hideMadeToOrder}
      valuePropsLength={valueProps.length}
    >
      <div className="container">
        {valueProps.map((valueProp, i) => (
          <Value key={i} valueProp={valueProp} className="value-prop" />
        ))}
      </div>
    </Wrapper>
  );
}

export default ValueProposition;

export const valuesPropsToShow = (
  categoryId,
  assemblyAvailable,
  isWarranty,
  productData
) => {
  const isMarketplace = productData?.frame?.type?.id == 2;
  const isMoeSupplier = productData?.supplier.id == 27;
  const isADSupplier = productData?.supplier.id == 16;
  const warranty = productData?.warranty;
  const isFinalSale = productData?.frame?.is_final_sale;
  const isBedroomSets =
    productData?.frame?.primarySubcategory.category_id == 39;

  const getWarrantyText = () => {
    if (warranty == 365) {
      return `1-Year Warranty`;
    } else {
      return `${warranty}-Day Warranty`;
    }
  };

  const getWarrantyDesc = () => {
    if (warranty == 365) {
      return `We’ve got your back with a year warranty on this piece`;
    } else {
      return `We’ve got your back with a ${warranty} day warranty on this piece`;
    }
  };

  return [
    ...(isMoeSupplier || isFinalSale || isADSupplier
      ? []
      : [
          {
            name: `30-day Returns`,
            icon: `ti-box-return`,
            description: `Don’t love it? We’ll take it back within 30 days`
          }
        ]),

    // ...(isADSupplier
    //   ? [
    //       {
    //         name: `100% American Made`,
    //         icon: `ti-us-flag`,
    //         description: `Our fabrics are digitally printed in America on American cotton`
    //       }
    //     ]
    //   : []),

    ...(categoryId == 13 && !assemblyAvailable
      ? [
          {
            name: `White Glove Delivery`,
            icon: `ti-white-glove`,
            description: `We’ll schedule delivery, unwrap, assemble + clean up`
          }
        ]
      : [
          // {
          //   name: `Delivered to Your Front Door`,
          //   icon: `ti-box`,
          //   description: `Your piece will be FedEx-ed right to your door`
          // }
        ]),

    ...(isWarranty
      ? [
          {
            name: getWarrantyText(),
            icon: `ti-ribbon`,
            description: getWarrantyDesc()
          }
        ]
      : []),

    {
      name: `Fair Prices`,
      //name: `Fair Prices + Financing`,
      icon: `ti-price`,
      description: `We offer affordable pricing`
      //description: `We offer affordable pricing + financing through Affirm`
    },

    ...(isMarketplace || isBedroomSets
      ? []
      : [
          {
            name: `Sustainably Made to Order`,
            icon: `ti-no-waste`,
            description: `Made to order means less waste and better quality`
          }
        ])
  ];
};
